import * as yup from 'yup';

import { CreditCardFields } from '../../../types';

/**
 * Creates schema validatiors for credit card
 * @param {Array} requiredFields - collection of required fields
 * @returns {Yup.Schema} validation schema
 */
const createCreditCardValidationSchema = (requiredFields: string[] = []) => {
  const schema: {
    [key in keyof CreditCardFields]: yup.StringSchema;
  } = {
    firstName: yup.string(),
    lastName: yup.string(),
  };

  (requiredFields as Array<keyof CreditCardFields>).forEach((fieldName) => {
    if (schema[fieldName]) {
      schema[fieldName] = schema[fieldName].required('required');
    }
  });

  const schemaValidator = yup.object(schema);

  return schemaValidator;
};

export default createCreditCardValidationSchema;
